const duplicateTranslationKey = (key: string): string => key;

export const translationUploadData_sv_part3 = {
  originalEntries: "Ursprungliga poster",
  entry: "Post",
  suggestedMergedEntry: "Föreslagen sammanlagd post",
  aiExplanation: "AI-förklaring:",
  applyMerge: "Tillämpa sammanslagning",
  applying: "Tillämpar...",
  [duplicateTranslationKey("cancel")]: "Avbryt",
  generateImprovementSuggestions: "Generera förbättringsförslag",
  generateImprovementSuggestion: "Generera förbättringsförslag",
  aiSuggestion: "AI-förslag",
  applySuggestion: "Tillämpa förslag",
  [duplicateTranslationKey("generating")]: "Genererar...",
  hideAIRecommendations: "Dölj AI-genererade förbättringsrekommendationer",
  showAIRecommendations: "Visa AI-genererade förbättringsrekommendationer",
  affectedItems: "Berörda poster:",
  moreItems: "fler poster",
  current: "Nuvarande:",
  improved: "Förbättrad:",
  suggestion: "Förslag:",
  applyThisSuggestion: "Tillämpa det här förslaget",
  identicalTitles: "Identiska titlar i samma kunskapsbas",
  similarTitlesContent: "Mycket liknande titlar och relaterat innehåll",
  similarContent: "Mycket liknande innehåll i samma kunskapsbas",
  applyingChanges: "Tillämpar...",
  refineWithFeedback: "Förfina med återkoppling",
  refinePlaceholder:
    "Skriv en kort anteckning till AI:n (t.ex. kortare, vänligare ton, inkludera öppettider...)",
  refineSuggestion: "Förfina förslag",
  suggestionRefined: "Förslag förfinat!",
  failedToRefine: "Det gick inte att förfina förslaget",
  weakOrIncompleteContent: "Svagt eller ofullständigt innehåll",
  weakContentDesc:
    "poster verkar ofullständiga eller dåligt formulerade. Lägg till saknade detaljer och förbättra tydligheten.",
  unclearOrVaguePrompts: "Otydliga eller vaga uppmaningar",
  unclearPromptsDesc:
    "uppmaningar kan vara mer specifika. Överväg att lägga till mer kontext och tydliga instruktioner.",
  missingClearCTA: "Saknar tydlig uppmaning till handling",
  missingCTADesc:
    "uppmaningar saknar en tydlig uppmaning till handling. Lägg till specifika nästa steg för användarna.",
  overlyGenericPrompts: "Alltför generiska uppmaningar",
  genericPromptsDesc: "uppmaningar är för generiska. Gör dem mer specifika för din verksamhet.",
  overlyLongContent: "Alltför långt innehåll",
  longContentDesc:
    "uppmaningar är mycket långa. Överväg att dela upp dem i mindre, fokuserade delar.",
  reviewOldContent: "Granska gammalt innehåll",
  oldContentDesc:
    "poster är äldre än 6 månader och kan behöva uppdateras för att återspegla aktuell bästa praxis.",
  expiredContentCleanup: "Rensning av utgånget innehåll",
  expiredContentDesc: "utgångna poster som kan tas bort på ett säkert sätt.",
  found: "Hittade",
  bugStatus: "Felstatus",
  reported: "rapporterat",
  report: "Rapportera",
  resolved: "löst",
  [duplicateTranslationKey("suggestion")]: "förslag",
  test_feedback: "testfeedback",
  markResolved: "Markera som löst",
  removeStatus: "Ta bort felstatus",
  reportBug: "Rapportera fel",
  reportInternalBug: "Rapportera internt fel",
  reportSuggestion: "Rapportera förslag",
  reportCriticalBug: "Rapportera kritiskt fel",
  reportAdminBug: "Rapportera adminfel",
  critical_bug: "kritiskt fel",
  admin_bug: "adminfel",
  showBugReport: "Rapportera",
  hideBugReport: "Dölj felrapport",
  reportTypeOptions: "Välj rapporttyp eller lägg till kommentar",
  assign: "Tilldela",
  assignedTo: "Tilldelad till",
  assignedToMe: "Tilldelad till mig",
  assignedToYou: "Tilldelad till dig",
  unassign: "Ta bort tilldelning",
  unassigned: "Otilldelad",
  unknownUser: "Okänd användare",
  addCommentOrViewComments: "Lägg till kommentar / Visa kommentarer",
  commentsLabel: "Kommentarer",
  noComments: "Inga kommentarer ännu",
  usernamePlaceholder: "Ditt namn",
  addCommentPlaceholder: "Lägg till en kommentar...",
  addComment: "Lägg till kommentar",
  adding: "Lägger till...",
  editComment: "Redigera kommentar",
  deleteComment: "Ta bort kommentar",
  confirmDeleteComment: "Är du säker på att du vill ta bort den här kommentaren?",
  save: "Spara",
  commentPlaceholder: "Kommentar",
  unreadComments: "Olästa kommentarer",
  title: "Titel",
  text: "Text",
  selectIndexes: "Välj index",
  enterTitle: "Ange titel",
  enterText: "Ange text",
  selectExpirationDate: "Välj utgångsdatum",
  errorUploadingData: "Fel vid uppladdning av data",
  "Title is Required": "Titel krävs",
  "Index is Required": "Index krävs",
  uploadDataTitle: "Ladda upp data",
  authTokenNotFound: "Autentiseringstoken hittades inte.",
  errorFetchingUsers: "Fel vid hämtning av användare",
  errorFetchingUserIndexes: "Fel vid hämtning av användarens kunskapsbasindex",
  noTextContentFound: "Inget textinnehåll hittades i PDF",
  errorExtractingPdfText: "Fel vid extrahering av text från PDF. Försök igen.",
  selectAccessibleUser: "Välj tillgänglig användare",
  selectAccessibleUserPlaceholder: "Välj tillgänglig användare",
  selectUser: "Välj användare",
  selectUserToManage: "Välj användare att hantera",
  selectUserToManagePlaceholder: "Välj användare att hantera",
  noMatchingResults: "Inga matchande resultat hittades",
  noDataFoundForUser: "Inga data hittades för {username}",
  noDataFound: "Inga data hittades",
  pleaseSelectUserBase: "Välj en användare",
  fromAccessibleUsers: "från dina tillgängliga användare",
  toManageTheirData: "för att hantera deras data",
  pleaseSelectOrganization: "Välj en organisation.",
  pleaseSelectOrganizationToManage: "Välj en organisation för att hantera deras data",
  selectOrganization: "Välj organisation",
  selectOrganizationPlaceholder: "Välj organisation",
  noDataFoundForOrganization: "Inga data hittades för {name}",
};
